import * as React from 'react';
import { Controller, UseControllerReturn, useFormContext } from 'react-hook-form';
import { IRichTextEditorProps, Label, RichTextEditor } from '@agilepoint/wat-react-ux';
import { IBaseFormFieldProps, FieldBlock, StyledErrorMessage } from '@agilepoint/wat-react-ux-form-fields';
import { ErrorMessage } from '@hookform/error-message';
import styled from 'styled-components';

interface IRichTextFormFieldProps extends IBaseFormFieldProps, Omit<IRichTextEditorProps, 'name' | 'label'> {
}

const StyledRichTextEditor = styled(RichTextEditor)`
    width: 100%;
    height: 400px;
`;

export function RichTextField(props: IRichTextFormFieldProps) {
    const { className, name, label, validationRules, gap, title, defaultValue, ...restProps } = props;
    const { control, formState: { errors } } = useFormContext();

    const renderRichTextControl = React.useCallback(({ field: { onChange, value } }: UseControllerReturn) => (
        <StyledRichTextEditor {...restProps} value={value} onValueChange={onChange} />
    ), [restProps]);

    return (
        <FieldBlock gap={gap} orientation="vertical" className={className} title={title}>
            {label ? <Label required={validationRules && !!validationRules.required}>{label}</Label> : <></>}
            <Controller control={control} name={name} defaultValue={defaultValue}
                render={renderRichTextControl} rules={validationRules} />
            <ErrorMessage errors={errors} name={name} as={StyledErrorMessage} />
        </FieldBlock>
    );
}
